import angular from 'angular';

import Component from './metric-box.component';

const MetricBox = angular
    .module('control-room.commons.data.components.metric-box', [])
    .component('crMetricBox', Component);

export default MetricBox;
